var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity"},[_c('i',{staticClass:"back",on:{"click":_vm.back}}),_vm._l((_vm.images),function(image,index){return _c('img',{key:index,staticClass:"img",attrs:{"src":image}})}),_c('div',{staticClass:"btn-static"}),_c('img',{staticClass:"btn",attrs:{"src":_vm.btnImage},on:{"click":_vm.clickToBuy}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }